(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-live-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var galleries = document.querySelectorAll('.dc-gallery');
    galleries.forEach(function (root) {
      if (root.dataset.galleryInit === '1') return;
      root.dataset.galleryInit = '1';
      initGallery(root);
    });

    function initGallery(root) {
      var id = root.id.replace('dc-gallery-', '').replace(/-/g, '_');
      var data = window['DC_GALLERY_DATA_' + id] || [];

      // De-dupe by image src (not product URL) so a product can contribute several
      // distinct images to the wall, while identical images -- e.g. the same product
      // pulled in via two collections -- still collapse to one.
      var seenSrc = {};
      data = data.filter(function (d) {
        if (!d || !d.src || seenSrc[d.src]) return false;
        seenSrc[d.src] = 1;
        return true;
      });

      var viewport = root.querySelector('[data-gallery-viewport]');
      var canvasEl = root.querySelector('[data-gallery-canvas]');
      var loaderEl = root.querySelector('[data-gallery-loader]');
      var instructionsEl = root.querySelector('[data-gallery-instructions]');

      if (!data.length) {
        if (loaderEl) loaderEl.classList.add('is-hidden');
        return;
      }

      var vw = viewport.clientWidth;
      var vh = viewport.clientHeight;
      var isMobile = vw < 640;
      var GAP = isMobile ? 14 : 24;
      // Tile size is driven by the section setting (Small / Medium / Large).
      var COL_WIDTH = isMobile
        ? (parseInt(root.dataset.tileMobile, 10) || 180)
        : (parseInt(root.dataset.tileDesktop, 10) || 300);
      // Mobile keeps a uniform 1:1 square grid; desktop stays masonry (varying heights).
      var TILE_HEIGHTS = isMobile
        ? [COL_WIDTH]
        : [280, 360, 320, 400, 300, 380, 340, 420];
      var TOTAL_COLS = isMobile ? 6 : 8;
      var tileWidth = COL_WIDTH;

      // Build the tile pool. The 3x3 wrap repeats this set, so a moderate
      // distinct count still reads as an endless wall while keeping the DOM light.
      var MAX_TILES = isMobile ? 60 : 130;
      var MIN_TILES = 40;
      var distinctCount = data.length;
      var allImages = data.slice();
      while (allImages.length < MIN_TILES && data.length > 0) {
        allImages = allImages.concat(data.slice());
      }
      for (var i = allImages.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = allImages[i];
        allImages[i] = allImages[j];
        allImages[j] = tmp;
      }
      if (allImages.length > MAX_TILES) allImages = allImages.slice(0, MAX_TILES);

      // Trim to full rows so the 3x3 wrap tiles cleanly (a ragged last row is
      // what leaves empty gaps where the repeated copies meet).
      var remainder = allImages.length % TOTAL_COLS;
      if (remainder && allImages.length - remainder >= TOTAL_COLS) {
        allImages = allImages.slice(0, allImages.length - remainder);
      }

      // When the source set is smaller than the wall (a small drop), the pool
      // above necessarily repeats images. Reorder so no tile sits directly beside
      // or directly above an identical one -- that's what produced "the same sock
      // next to itself." Can't be perfect when distinct count < columns, but it
      // removes the obvious touching duplicates.
      if (distinctCount > 1) {
        for (var p = 0; p < allImages.length; p++) {
          var col = p % TOTAL_COLS;
          for (var attempt = 0; attempt < allImages.length; attempt++) {
            var clashLeft = col > 0 && allImages[p - 1].src === allImages[p].src;
            var clashUp = p >= TOTAL_COLS && allImages[p - TOTAL_COLS].src === allImages[p].src;
            if (!clashLeft && !clashUp) break;
            var swapIdx = (p + 1 + attempt) % allImages.length;
            if (swapIdx === p) continue;
            var sw = allImages[p];
            allImages[p] = allImages[swapIdx];
            allImages[swapIdx] = sw;
          }
        }
      }

      function layoutGrid(pool) {
        var colHeights = new Array(TOTAL_COLS).fill(0);
        var laid = [];
        for (var k = 0; k < pool.length; k++) {
          var col = k % TOTAL_COLS;
          var row = Math.floor(k / TOTAL_COLS);
          // Height varies per ROW (not per tile) so every column ends at the same
          // total height -- that's what lets the 3x3 wrap tile with no empty voids.
          var h = TILE_HEIGHTS[row % TILE_HEIGHTS.length];
          var x = col * (tileWidth + GAP);
          var y = colHeights[col];
          colHeights[col] += h + GAP;
          laid.push({ img: pool[k], x: x, y: y, w: tileWidth, h: h });
        }
        return {
          tiles: laid,
          width: TOTAL_COLS * (tileWidth + GAP),
          height: Math.max.apply(null, colHeights)
        };
      }

      var baseGrid = layoutGrid(allImages);
      var gridW = baseGrid.width;
      var gridH = baseGrid.height;

      canvasEl.style.width = gridW * 3 + 'px';
      canvasEl.style.height = gridH * 3 + 'px';

      var offsetX = -(gridW + gridW / 2 - vw / 2);
      var offsetY = -(gridH + gridH / 2 - vh / 2);

      function wrapOffset() {
        var viewLeft = -offsetX;
        var viewTop = -offsetY;
        if (viewLeft < gridW * 0.5) offsetX -= gridW;
        else if (viewLeft > gridW * 2) offsetX += gridW;
        if (viewTop < gridH * 0.5) offsetY -= gridH;
        else if (viewTop > gridH * 2) offsetY += gridH;
      }

      function updateTransform() {
        canvasEl.style.transform = 'translate(' + offsetX + 'px,' + offsetY + 'px)';
      }
      updateTransform();

      var createdTiles = [];

      function createAllTiles() {
        var frag = document.createDocumentFragment();
        for (var cy = 0; cy < 3; cy++) {
          for (var cx = 0; cx < 3; cx++) {
            var ox = cx * gridW;
            var oy = cy * gridH;
            for (var t = 0; t < baseGrid.tiles.length; t++) {
              var d = baseGrid.tiles[t];
              var tx = d.x + ox;
              var ty = d.y + oy;
              // Real anchor, not a div: keeps long-press, open-in-new-tab and
              // middle-click working, and makes every tile a crawlable link to
              // its product. The didDrag guard below preventDefault()s it.
              var el = document.createElement('a');
              el.className = 'dc-gallery__tile';
              el.href = d.img.url;
              el.draggable = false;
              el.style.left = tx + 'px';
              el.style.top = ty + 'px';
              el.style.width = d.w + 'px';
              el.style.height = d.h + 'px';

              var imgEl = document.createElement('img');
              imgEl.draggable = false;
              imgEl.loading = 'lazy';
              imgEl.decoding = 'async';
              imgEl.alt = d.img.name;
              el.appendChild(imgEl);

              el._x = tx;
              el._y = ty;
              el._w = d.w;
              el._h = d.h;
              el._src = d.img.src;
              el._url = d.img.url;
              el._name = d.img.name;
              el._price = d.img.price;
              el._img = imgEl;
              el._loaded = false;

              frag.appendChild(el);
              createdTiles.push(el);
            }
          }
        }
        canvasEl.appendChild(frag);
      }

      function loadVisibleTiles() {
        var pad = 300;
        var vl = -offsetX - pad;
        var vt = -offsetY - pad;
        var vr = -offsetX + vw + pad;
        var vb = -offsetY + vh + pad;
        for (var k = 0; k < createdTiles.length; k++) {
          var el = createdTiles[k];
          if (el._loaded) continue;
          if (el._x + el._w > vl && el._x < vr && el._y + el._h > vt && el._y < vb) {
            el._img.src = el._src;
            el._loaded = true;
          }
        }
      }

      // Reduced motion: the ambient drift is a rAF loop, so CSS cannot stop it.
      // Inertia after a deliberate drag is direct manipulation and stays --
      // what comes off is the motion the visitor did not ask for.
      var reduceMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Desktop reveals on hover; touch reveals on the first tap. matchMedia
      // rather than a UA sniff, and it decides whether the "tap again" cue is
      // drawn at all.
      var hasHover = !window.matchMedia
        || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      // Drag to pan + motion (one rAF loop handles inertia and ambient drift)
      var isDragging = false;
      var didDrag = false;
      var dragStart = { x: 0, y: 0 };
      var dragOrigin = { x: 0, y: 0 };
      var velocity = { x: 0, y: 0 };
      var lastMouse = { x: 0, y: 0 };
      var lastTime = 0;
      var driftActive = !reduceMotion;
      var driftAngle = 0;
      var revealedTile = null;
      var galleryVisible = true;
      var lastLoadX = offsetX;
      var lastLoadY = offsetY;

      function maybeLoad(force) {
        if (force || Math.abs(offsetX - lastLoadX) > 120 || Math.abs(offsetY - lastLoadY) > 120) {
          loadVisibleTiles();
          lastLoadX = offsetX;
          lastLoadY = offsetY;
        }
      }

      function pointerDown(x, y) {
        isDragging = true;
        didDrag = false;
        driftActive = false;
        dragStart = { x: x, y: y };
        dragOrigin = { x: offsetX, y: offsetY };
        velocity = { x: 0, y: 0 };
        lastMouse = { x: x, y: y };
        lastTime = Date.now();
        root.classList.add('is-dragging');
      }

      function pointerMove(x, y) {
        if (!isDragging) return;
        var dx = x - dragStart.x;
        var dy = y - dragStart.y;
        if (!didDrag && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) didDrag = true;
        offsetX = dragOrigin.x + dx;
        offsetY = dragOrigin.y + dy;
        wrapOffset();
        updateTransform();
        maybeLoad(false);
        var now = Date.now();
        var dt = now - lastTime;
        if (dt > 0) {
          velocity.x = (x - lastMouse.x) / dt * 16;
          velocity.y = (y - lastMouse.y) / dt * 16;
        }
        lastMouse = { x: x, y: y };
        lastTime = now;
      }

      function pointerUp() {
        if (!isDragging) return;
        isDragging = false;
        root.classList.remove('is-dragging');
        setTimeout(function () { didDrag = false; }, 50);
        // Do not restart the drift under a live reveal -- the whole point of
        // the reveal is that the wall holds still while it is read.
        setTimeout(function () { resumeDrift(); }, 4000);
      }

      function resumeDrift() {
        if (reduceMotion || revealedTile) return;
        driftActive = true;
      }

      function buildOverlay(el) {
        if (el._overlay) return;
        var ov = document.createElement('div');
        ov.className = 'dc-gallery__overlay';
        var n = document.createElement('div');
        n.className = 'dc-gallery__name';
        n.textContent = el._name;
        var p = document.createElement('div');
        p.className = 'dc-gallery__price';
        p.textContent = el._price;
        ov.appendChild(n);
        ov.appendChild(p);
        if (!hasHover) {
          var c = document.createElement('span');
          c.className = 'dc-gallery__commit';
          c.textContent = 'Shop';
          ov.appendChild(c);
        }
        el.appendChild(ov);
        el._overlay = ov;
      }

      function reveal(el) {
        if (revealedTile === el) return;
        clearReveal();
        buildOverlay(el);
        el.classList.add('is-revealed');
        revealedTile = el;
        driftActive = false; // hold the wall still while the tile is read
      }

      function clearReveal() {
        if (!revealedTile) return;
        revealedTile.classList.remove('is-revealed');
        revealedTile = null;
      }

      function tick() {
        if (galleryVisible && !isDragging) {
          var moved = false;
          if (Math.abs(velocity.x) > 0.2 || Math.abs(velocity.y) > 0.2) {
            velocity.x *= 0.95;
            velocity.y *= 0.95;
            offsetX += velocity.x;
            offsetY += velocity.y;
            moved = true;
          } else if (driftActive) {
            driftAngle += 0.003;
            offsetX += Math.sin(driftAngle) * 0.15;
            offsetY += Math.cos(driftAngle * 0.7) * 0.1;
            moved = true;
          }
          if (moved) {
            wrapOffset();
            updateTransform();
            maybeLoad(false);
          }
        }
        requestAnimationFrame(tick);
      }

      // Delegated listeners (one each) instead of one per tile.
      //
      // REVEAL-THEN-COMMIT. Tiles are anchors now, so "do nothing" means
      // preventDefault() -- the browser navigates otherwise.
      //   drag  -> never reveals, never navigates (the existing 4px guard)
      //   hover -> reveal, and the click that follows is already the commit
      //   touch -> first tap reveals, second tap on the SAME tile commits,
      //            a tap on a different tile moves the reveal there
      // Modified clicks (cmd/ctrl/shift/middle) are left alone so
      // open-in-new-tab keeps working -- one of the reasons for the anchor.
      canvasEl.addEventListener('click', function (e) {
        var el = e.target.closest('.dc-gallery__tile');
        if (didDrag) {
          e.preventDefault();
          return;
        }
        if (!el) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (hasHover) return;              // hover already did the revealing
        if (revealedTile === el) return;   // second tap -- let the link through
        e.preventDefault();
        reveal(el);
      });

      canvasEl.addEventListener('mouseover', function (e) {
        if (!hasHover) return;
        var el = e.target.closest('.dc-gallery__tile');
        if (!el) return;
        reveal(el);
      });

      canvasEl.addEventListener('mouseout', function (e) {
        if (!hasHover) return;
        var el = e.target.closest('.dc-gallery__tile');
        if (!el || el !== revealedTile) return;
        if (e.relatedTarget && el.contains(e.relatedTarget)) return;
        clearReveal();
        resumeDrift();
      });

      // A tap on the wall itself, off any tile, dismisses the reveal and lets
      // the wall start drifting again.
      viewport.addEventListener('click', function (e) {
        if (didDrag || !revealedTile) return;
        if (e.target.closest('.dc-gallery__tile')) return;
        clearReveal();
        resumeDrift();
      });

      viewport.addEventListener('mousedown', function (e) {
        pointerDown(e.clientX, e.clientY);
      });
      document.addEventListener('mousemove', function (e) {
        pointerMove(e.clientX, e.clientY);
      });
      document.addEventListener('mouseup', pointerUp);

      viewport.addEventListener('touchstart', function (e) {
        pointerDown(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        pointerMove(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      viewport.addEventListener('touchend', pointerUp);

      window.addEventListener('resize', function () {
        vw = viewport.clientWidth;
        vh = viewport.clientHeight;
        wrapOffset();
        updateTransform();
        maybeLoad(true);
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          galleryVisible = entries[0].isIntersecting;
        }, { threshold: 0 });
        io.observe(root);
      }

      createAllTiles();
      loadVisibleTiles();
      tick();

      setTimeout(function () {
        if (loaderEl) loaderEl.classList.add('is-hidden');
      }, 600);

      if (instructionsEl) {
        setTimeout(function () { instructionsEl.style.opacity = '0'; }, 5000);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
